import type { Reference } from '@apollo/client';
import { offsetLimitPagination } from '@apollo/client/utilities';

import { defaultKeyArgsFn } from './defaultKeyArgsFn';

function offsetLimitPaginationMerge<T = Reference>(
  existing: T[],
  incoming: T[],
  { args }: { args: (Record<string, unknown> & { offset?: number; limit?: number }) | null }
) {
  const merged = existing ? existing.slice(0) : [];

  const { offset = 0, limit = incoming.length } = args ?? {};
  for (let i = offset; i < limit + offset; ++i) {
    merged[i] = incoming[i - offset];
  }

  return merged.filter(Boolean);
}

function offsetLimitPaginationListMerge<T = Reference>(
  existing: T[],
  incoming: T[],
  { variables }: { variables?: Record<string, unknown> & { offset?: number; limit?: number } }
) {
  return offsetLimitPaginationMerge(existing, incoming, { args: variables ?? null });
}

export const paginationPolicy = () => ({
  ...offsetLimitPagination(defaultKeyArgsFn()),
  merge: offsetLimitPaginationMerge,
});
/** Add pagination list policy for responses with list field - merge based on query variables, not query args, since list field does not have pagination args attached on its level */
export const paginationListPolicy = () => ({
  ...offsetLimitPagination(defaultKeyArgsFn()),
  merge: offsetLimitPaginationListMerge,
});
